module.exports = __webpack_public_path__ + "img/notif-slider.e648344.svg";